import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import EnhancedToolbar from '../../widgets/Toolbar';
import "./../../Grid.css";
import "./../../Form.css";
import "./../../App.css";
import "./Consultant.css";
import { ConsultantForm } from './ConsultantForm';
import { ViewContainer } from "../../View";
import ViewUtils from "./../../ViewUtils";
import AlertItem from "../../widgets/AlertItem";
import withMenuPermission from "../../widgets/withMenuPermission";


const utils = new ViewUtils();


const consultantRef = React.createRef();

class Consultant extends Component {

    state = {
        ConsultantDetails: {
            Person: {
                FirstName: "",
                Surname: "",
                IDNo: ""
            }
        },
        toolbarConfig: {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'close', label: 'CLOSE', tooltip: 'Close', icon: 'CloseIcon' },
                        
                    ]
                },
                {
                    type: "devider"
                },
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'save', label: 'SAVE', tooltip: 'Save', icon: 'SaveIcon', visible: this.props.menuPermissionItem.Edit},
                        //{
                        //    contextMenu: [
                        //        { id: "registrationDetails", description: "Registration Details"},
                        //        { id: "registrationHistory", description: "Registration History"  }
                        //    ],
                        //    id: "registration", label: "Registration", width: "120px",  visible: this.props.menuPermissionItem.Edit
                        //},
        
                        //{
                        //    contextMenu: [
                        //        { id: "skillsProgramme", description: "Skills Programme" },
                        //        { id: "learnership", description: "Learnership" }
                        //    ],
                        //    id: 'programs', label: 'Programmes', width: "120px",  visible: this.props.menuPermissionItem.Edit
                        //},
        
                        //{ id: 'provider', label: 'Provider', tooltip: '',  visible: this.props.menuPermissionItem.Edit },
                        ////{ id: 'idDocument', label: 'ID Document', tooltip: 'Identity Document' },
                        //{ id: 'crm', label: 'CRM', tooltip: 'Client Relationship Management',  visible: this.props.menuPermissionItem.Edit }
        
                    ]
                }
            ]
        }
    };

    handleFormValueChange(values) {
        if (!utils.isNull(values)) {
            this.setState({ ConsultantDetails: values });
        }
    }

    handleToolbarButtonClick(buttonId) {
        if ("save" === buttonId) {
            this.save();
        } else if ("close" === buttonId) {
            this.close();
        } else if ("idDocument" === buttonId) {
            this.props.history.push({
                pathname: '/consultantIDDocument',
                state: {
                    ConsultantID: this.props.location.state.selection,
                    ConsultantName: `${this.state.ConsultantDetails.FirstName} ${this.state.ConsultantDetails.Surname}`,
                    ConsultantIDNo: `${this.state.ConsultantDetails.IDNo}`
                }
            })
        }else if ("crm" === buttonId) {
            this.props.history.push({
                pathname: '/consultantCRM',
                state: {
                    selection: this.props.location.state.selection,
                    ConsultantName: `${this.state.ConsultantDetails.FirstName} ${this.state.ConsultantDetails.Surname}`,
                    ConsultantIDNo: `${this.state.ConsultantDetails.IDNo}`
                }
            })
        } else if ("provider" === buttonId) {
            this.props.history.push({
                pathname: '/ConsultantProviderSearch',
                state: {
                    ConsultantID: this.props.location.state.selection,
                    ConsultantName: `${this.state.ConsultantDetails.FirstName} ${this.state.ConsultantDetails.Surname}`,
                    ConsultantIDNo: `${this.state.ConsultantDetails.IDNo}`
                }
            })
        }
    }

    handleToolbarButtonMenuClick(menu) {
        if ("registrationDetails" === menu.id) {
            this.props.history.push({
                pathname: '/ConsultantRegistrationDetails',         
                state: {
                    selection: this.props.location.state.selection,
                    ConsultantName: `${this.state.ConsultantDetails.FirstName} ${this.state.ConsultantDetails.Surname}`,
                    ConsultantIDNo: `${this.state.ConsultantDetails.IDNo}`
                }
            })
        } else if ("registrationHistory" === menu.id) {
                this.props.history.push({
                    pathname: '/ConsultantRegistrationHistory',
                    state: {
                        ConsultantID: this.props.location.state.selection,
                        ConsultantName: this.state.ConsultantDetails.FirstName + " " + this.state.ConsultantDetails.Surname,
                        ConsultantIDNo: `${this.state.ConsultantDetails.IDNo}`
                    }
                })

        } else if ("skillsProgramme" === menu.id) {
            this.props.history.push({
                pathname: '/ConsultantSkillsProgrammeSearch',
                state: {
                    ConsultantID: this.props.location.state.selection,
                    ConsultantName: this.state.ConsultantDetails.FirstName + " " + this.state.ConsultantDetails.Surname,
                    ConsultantIDNo: `${this.state.ConsultantDetails.IDNo}`
                }
            })
        } else if ("learnership" === menu.id) {
            this.props.history.push({
                pathname: '/Consultantlearnerships',
                state: {
                    ConsultantID: this.props.location.state.selection,
                    ConsultantName: this.state.ConsultantDetails.FirstName + " " + this.state.ConsultantDetails.Surname,
                    ConsultantIDNo: `${this.state.ConsultantDetails.IDNo}`
                }
            })
        }
    }

    close() {
        this.props.history.push('/consultantSearch');
    }

    successCallback = () => {

        this.setState({ message: "Consultant updated successfully", messageStyle: "SUCCESS" });
    }

    save() {
        let formValue = consultantRef.current.getValue();
        if (formValue !== null && typeof formValue !== "undefined") {
            let input = JSON.stringify(formValue);

            utils.invokeUrl("api/sims/consultantdetails/UpdateConsultant", this.successCallback, () => { alert(utils.SYSTEM_ERROR_MESSAGE) }, {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem("token")
                },
                body: input
            });
        }
    }

    render() {
       
        return (
            <ViewContainer topPadding="0" title="">
                <p className="breadcrumbs">
                    {"Consultant / Mentor " + (this.state.ConsultantDetails.FirstName !== null ? "> " + this.state.ConsultantDetails.FirstName + " " + this.state.ConsultantDetails.Surname + (this.state.ConsultantDetails.IDNo !== null ? " - " + this.state.ConsultantDetails.IDNo : "") : "> Add")}
                </p>

                <AlertItem message={this.state.message} alertStyle={this.state.messageStyle} />

                <table width="100%">
                    <tbody>
                        <tr>
                            <td>
                                <EnhancedToolbar highlight={false} title="Consultant" buttonClickHandler={(buttonId) => this.handleToolbarButtonClick(buttonId)}
                                    buttonMenuClickHandler={(menu) => this.handleToolbarButtonMenuClick(menu)} enabled={true} config={this.state.toolbarConfig} />
                            </td>
                        </tr>
                        <tr>
                            <td className="formContainer">
                                <div style={{ height: "64vh", maxHeight: "64vh" }}>
                                    <ConsultantForm ref={consultantRef} id={this.props.location.state.selection} valueChangeHandler={(values) => this.handleFormValueChange(values)} editPermission = {this.props.menuPermissionItem.Edit} />
                                </div>
                            </td> 
                        </tr>
                    </tbody>
                </table>
            </ViewContainer>
        );
    }
}

export default withRouter(withMenuPermission(Consultant));
